import { Component, Input, ElementRef, EventEmitter, Output, ViewChild, OnInit, AfterViewInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, take } from 'rxjs/operators';

import { ApiError, AuthService, BaseFilterCollapseService, MessageService } from '../../../../core';
import { Lead } from '../lead';
import { LeadFilter } from './lead-filter';
import { LeadFilterStorageService } from './lead-filter-storage.service';
import { Estado, EstadoCrudHttpService } from '../../../estado';
import { Cidade, CidadeSubRegiao, CidadeSubRegiaoBairro, CidadeSearchesHttpService } from '../../../cidade';
import { RegiaoCidadeSubRegiaoHttpService } from '../../../regiao/cidade/sub-regiao/services';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-lead-filter',
    templateUrl: 'lead-filter.component.html',
    styleUrls: ['./lead-filter.component.less']
})
export class LeadFilterComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
    idUsuarioLogado: number;
    /** Se é um representante */
    isRepresentante: boolean;

    // Filter
    @Input() filter: LeadFilter;
    isFilterInitializing = false;
    isFilterInitialized = false;
    @Input() allowStorage = true;
    @Output() filterInitialized = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() filterCleaned = new EventEmitter<any>();

    // Filrer pesquisa
    filterPsqSubscription: Subscription;
    isFirstChangeFilterPsq = true;
    @ViewChild('filterPsq', {static: true}) filterPsq: NgModel;

    // Filter collapse
    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';

    subRegioes: CidadeSubRegiao[];
    bairros: CidadeSubRegiaoBairro[];
    estados: Estado[] = [];

    // Multiselects
    isFirstChangeUsuariosResponsaveis = true;
    isFirstChangeCampanhasOrigensMultiselect = true;
    isFirstChangeClassificacoesMultiselect = true;
    isFirstChangeTemperaturasMultiselect = true;
    isFirstChangeEstadosMultiselect = true;

    // Sub-regiões das cidades
    cidadesSubRegioes: CidadeSubRegiao[] = [];
    isFirstChangeCidadesSubRegioes = true;
    multiselectCidadesSubRegioesOptions: IMultiSelectOption[];
    multiselectCidadesSubRegioesSettings: IMultiSelectSettings = {
        enableSearch: true,
        containerClasses: 'container-multiselect container-multiselect-cidade-sub-regioes dropup',
        showCheckAll: true,
        showUncheckAll: true,
        dynamicTitleMaxItems: 0,
        fixedTitle: false
    }
    multiselectCidadesSubRegioesTexts: IMultiSelectTexts = {
        checkAll: 'Selecionar Todas',
        uncheckAll: 'Limpar',
        defaultTitle: 'Nenhuma Sub-Regiões',
        checked: 'Sub-Região',
        checkedPlural: 'Sub-Regiões',
        searchPlaceholder: 'Pesquisar...',
        allSelected: 'Todas Selecionadas',
        searchEmptyResult: 'Nenhuma sub-região encontrada',
        searchNoRenderText: 'Digite para pesquisar'
    }

    // Bairros das sub-regiões das cidades
    isFirstChangeCidadesSubRegioesBairros = true;
    multiselectCidadesSubRegioesBairrosOptions: IMultiSelectOption[];
    multiselectCidadesSubRegioesBairrosSettings: IMultiSelectSettings = {
        enableSearch: true,
        containerClasses: 'container-multiselect container-multiselect-cidade-sub-regioes-bairros dropup',
        showCheckAll: true,
        showUncheckAll: true,
        dynamicTitleMaxItems: 0,
        fixedTitle: false
    }
    multiselectCidadesSubRegioesBairrosTexts: IMultiSelectTexts = {
        checkAll: 'Selecionar Todos',
        uncheckAll: 'Limpar',
        defaultTitle: 'Nenhum Bairro',
        checked: 'Bairro',
        checkedPlural: 'Bairros',
        searchPlaceholder: 'Pesquisar...',
        allSelected: 'Todos Selecionados',
        searchEmptyResult: 'Nenhum bairro encontrado',
        searchNoRenderText: 'Digite para pesquisar'
    }

    constructor(private authService: AuthService,
                private baseFilterCollapseService: BaseFilterCollapseService,
                private messageService: MessageService,
                private leadFilterStorageService: LeadFilterStorageService,
                private cidadeSearchesHttpService: CidadeSearchesHttpService,
                private regiaoCidadeSubRegiaoHttpService: RegiaoCidadeSubRegiaoHttpService,
                private estadoCrudHttpService: EstadoCrudHttpService) { }

    ngOnInit() {
        this.idUsuarioLogado = this.authService.getIdUsuario();
        this.isRepresentante = this.authService.isRepresentante();

        // Aplicando o filtro salvo no storage
        if (this.allowStorage) {
            this.leadFilterStorageService.applyFilter(this.filter);
        }
        // Iniciando filtro
        this.initFilter();
    }

    ngAfterViewInit() {
        if (!this.isCollapsedInDefault) {
            jQuery(this.filterCollapse.nativeElement).css('display', 'none');
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange()) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }

    /** Inicializa o filtro */
    private initFilter() {
        this.isFilterInitializing = true;
        this.isFilterInitialized = false;

        // Filter de pesquisa
        this.subscribeToFilterPsq();

        setTimeout(() => {
            this.isFilterInitializing = false;
            this.isFilterInitialized = true;
            this.filterInitialized.emit();
        }, 0);
    }

    // Realiza o subscribe nas alterações feitas no input do filtro da pesquisa
    private subscribeToFilterPsq() {
        this.filterPsqSubscription = this.filterPsq.valueChanges
            .pipe(
                debounceTime(1000), // Dando um debounce de 1000ms para emitir a alteração
                map(emittedValue => emittedValue?.trim()),
                distinctUntilChanged()
            )
            .subscribe(() => {
                if (this.isFirstChangeFilterPsq) {
                    this.isFirstChangeFilterPsq = false;
                    return;
                }

                if (this.filter.filterPsq?.trim().length > 0) {
                    this.filter.isFilterDirty = true;
                }

                this.filterChange.emit();
            });
    }

    /** Emite evento de alteração no filtro para atualizar a pesquisa */
    refresh() {
        this.close();
        this.filterChange.emit();
    }

    /** Limpa o filtro e atualiza a pesquisa */
    clear() {
        // Removendo os filtros
        this.baseFilterCollapseService.clear(this);

        this.close();
        this.filterCleaned.emit();
    }

    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }


    /** Ao alterar os usuários responsáveis */
    onChangeUsuariosResponsaveis() {
        if (this.isFirstChangeUsuariosResponsaveis) {
            this.isFirstChangeUsuariosResponsaveis = false;
            return;
        }

        this.filterChange.emit();
    }

    /** Ao alterar as origens */
    onChangeOrigensLead() {
        this.filterChange.emit();
    }

    /** Ao alterar as campanhas de origens */
    onChangeCampanhasOrigens() {
        if (this.isFirstChangeCampanhasOrigensMultiselect) {
            this.isFirstChangeCampanhasOrigensMultiselect = false;
            return;
        }

        this.filter.isFilterDirty = true;
    }

    /** Ao alterar as classificações */
    onChangeClassificacoes() {
        if (this.isFirstChangeClassificacoesMultiselect) {
            this.isFirstChangeClassificacoesMultiselect = false;
            return;
        }

        this.filterChange.emit();
    }

    /** Ao alterar as temperaturas */
    onChangeTemperaturasLead() {
        // if (this.isFirstChangeTemperaturasMultiselect) {
        //     this.isFirstChangeTemperaturasMultiselect = false;
        //     return;
        // }

        this.filterChange.emit();
    }

    /** Ao alterar a data de cadastro inicial/final */
    onChangeDataCadastro(date: Date) {
        if (date) {
            this.filter.isFilterDirty = true;
        }
    }


    /** Ao alterar os estados */
    onChangeEstados() {
        if (this.isFirstChangeEstadosMultiselect) {
            this.isFirstChangeEstadosMultiselect = false;
            return;
        }
        this.filter.isFilterDirty = true;
    }

    /** Ao selecionar a cidade */
    onSelectCidade(cidade: Cidade) {
        if (cidade) {
            this.filter.idCidade = cidade.id;
            this.filter.isFilterDirty = true;
            // Atualizando as sub-regiões e bairros da cidade selecionada
            this.searchCidadesSubRegioes();
        } else {
            this.clearCidadesSubRegioes();
        }
    }

    /** Ao remover a cidade  */
    onClearCidade() {
        this.filter.idCidade = null;
        this.clearCidadesSubRegioes();
    }

    /** Pesquisa as sub-regiões da cidade */
    private searchCidadesSubRegioes(clear = true) {
        if (clear) {
            this.clearCidadesSubRegioes();
        }

        this.searchCidadeSubRegioesDisponiveis()
            .then(subRegioes => {
                this.cidadesSubRegioes = subRegioes;

                // Adicionando as sub-regiões no multiselect
                if (subRegioes) {
                    const selects: IMultiSelectOption[] = [];
                    subRegioes.forEach(entity => {
                        selects.push({
                            id: entity.id,
                            name: entity.nome
                        });
                    });
                    this.multiselectCidadesSubRegioesOptions = selects;
                }

                // Pesquisando os bairros das sub-regiões
                this.searchCidadesSubRegioesBairros(clear);
            })
            .catch((error: ApiError) => {
                this.messageService.error(error.message, 'Erro ao pesquisar as sub-regiões e bairros da cidade', error);
                this.clearCidadesSubRegioes();
            });
    }

    /** Pesquisa as sub-regiões dispoiníveis na cidade */
    private searchCidadeSubRegioesDisponiveis(): Promise<CidadeSubRegiao[]> {
        return new Promise<CidadeSubRegiao[]>((resolve, reject) => {
            if (!this.filter.idCidade) {
                resolve([]);
                return;
            }

            const idsRepresentantes = this.isRepresentante ? [this.authService.getIdRepresentante()] : [];
            if (idsRepresentantes?.length > 0) { // Pesquisando somente as sub-regiões e bairros disponíveis para os representantes
                this.regiaoCidadeSubRegiaoHttpService.searchDisponiveisParaRepresentantes(idsRepresentantes, this.filter.idCidade)
                    .pipe(
                        take(1)
                    )
                    .subscribe(
                        subRegioes => resolve(subRegioes),
                        (error: ApiError) => reject(error)
                    );
            } else { // Pesquisando todas as sub-regiões e bairros da cidade
                this.cidadeSearchesHttpService.searchSubRegioes(this.filter.idCidade, true)
                    .pipe(
                        take(1)
                    )
                    .subscribe(
                        subRegioes => resolve(subRegioes),
                        (error: ApiError) => reject(error)
                    );
            }
        });
    }

    /** Ao alterar as sub-regiões das cidades */
    onChangeCidadesSubRegioes() {
        if (this.isFirstChangeCidadesSubRegioes) {
            this.isFirstChangeCidadesSubRegioes = false;
            return;
        }

        this.filter.isFilterDirty = true;
        this.searchCidadesSubRegioesBairros()
    }

    /** Limpa as sub-regiões e seus bairro*/
    private clearCidadesSubRegioes() {
        // Cidade Sub-Regiões
        this.cidadesSubRegioes = [];
        this.filter.idsCidadesSubRegioes = [];
        this.multiselectCidadesSubRegioesOptions = [];
        // Cidade Sub-Regiões Bairros
        this.clearCidadesSubRegioesBairros();
    }

    /** Pesquisa os bairros das sub-regiões */
    private searchCidadesSubRegioesBairros(clear = true) {
        if (clear) {
            this.clearCidadesSubRegioesBairros();
        }

        // Obtendo as sub-regiões selecionadas
        let subRegioes: CidadeSubRegiao[] = [];
        if (this.filter.idsCidadesSubRegioes?.length > 0) { // Filtrando somente as sub-regiões selecionadas no filtro
            subRegioes = this.cidadesSubRegioes?.filter(subRegiaoFilter => this.filter.idsCidadesSubRegioes?.includes(subRegiaoFilter.id));
        } else { // Todas as sub-regiões
            subRegioes = this.cidadesSubRegioes;
        }

        // Obtendo os bairros das sub-regiões selecionadas
        const bairros = new Map<number, CidadeSubRegiaoBairro>();
        subRegioes?.forEach(subRegiao => subRegiao.bairros?.forEach(bairro => bairros.set(bairro.id, bairro)));
        // Adicionando os bairros no multiselect
        if (bairros.size > 0) {
            const selects: IMultiSelectOption[] = [];
            bairros.forEach(bairro => {
                selects.push({
                    id: bairro.id,
                    name: bairro.nome
                });
            });
            this.multiselectCidadesSubRegioesBairrosOptions = selects;
        }
    }

    /** Limpa os bairros das sub-regiões */
    private clearCidadesSubRegioesBairros() {
        this.filter.idsCidadesSubRegioesBairros = [];
        this.multiselectCidadesSubRegioesBairrosOptions = [];
    }

    /** Ao alterar os bairros das sub-regiões */
    onChangeCidadesSubRegioesBairros() {
        if (this.isFirstChangeCidadesSubRegioesBairros) {
            this.isFirstChangeCidadesSubRegioesBairros = false;
            return;
        }

        this.filter.isFilterDirty = true;
    }
    ngOnDestroy() {
        this.filterPsqSubscription?.unsubscribe();
    }
}
